export function resolveLicenseGateFeatureKey(pathname: string, explicitFeatureKey?: string): string {
  if (explicitFeatureKey) return explicitFeatureKey;
  return `tool_${pathname.replace(/^\/tools\//, '').replace(/^\//, '').replace(/\//g, '_').replace(/-/g, '_')}`;
}
